import fetch from "@/service/fetch"

// 登录
export const login = async params => {
  const res = await fetch.post("/system/auth/login")(params)
  return res.data
}

// 退出登录
export const logout = async () => {
  const res = await fetch.get("/system/auth/logout")()
  return res.data
}

// 获取当前用户信息
export const getCurrentUserInfo = async () => {
  const res = await fetch.get("/system/auth/getCurrentUser")()
  return res.data
}

// 获取当前用户权限
export const getCurrentAuthor = async () => {
  const res = await fetch.get("/system/menu/list")()
  return res.data
}
